/**
 * Utility functions for file validation
 */

import { REQUIRED_HEADERS, REQUIRED_BLOQUEIOS_HEADERS } from './chartUtils';

/**
 * Validates that all required headers are present in the provided headers array
 * @param {string[]} headers - Array of header names from the file
 * @returns {string[]} Array of missing required headers (empty if all present)
 */
export function validateHeaders(headers) {
  const missingHeaders = REQUIRED_HEADERS.filter(h => !headers.includes(h));
  return missingHeaders;
}

/**
 * Validates that all required roadmap headers are present in the provided headers array
 * @param {string[]} headers - Array of header names from the roadmap file
 * @returns {string[]} Array of missing required headers (empty if all present)
 */
export function validateRoadmapHeaders(headers) {
  const required = ['Nome', 'Nível', 'Status']; // Nome, Nível e Status são obrigatórios
  return required.filter(h => !headers.includes(h));
}

/**
 * Validates that all required bloqueios headers are present in the provided headers array
 * @param {string[]} headers - Array of header names from the bloqueios file
 * @returns {string[]} Array of missing required headers (empty if all present)
 */
export function validateBloqueiosHeaders(headers) {
  // Import da nova validação
  const { validateHeaders } = require('./validations/bloqueios/validator');
  return validateHeaders(headers);
}

/**
 * Validates headers for Lead Time Breakdown with dynamic workflow columns
 * @param {string[]} headers - Array of header names from the file
 * @returns {object} { valid: boolean, missingRequired: string[], workflowColumns: string[], error: string }
 */
export function validateLeadTimeBreakdownHeaders(headers) {
  const requiredHeaders = ['ID', 'Tipo de Item', 'Closed Date'];
  
  // Verificar se todas as colunas obrigatórias estão presentes
  const missingRequired = requiredHeaders.filter(h => !headers.includes(h));
  
  if (missingRequired.length > 0) {
    return {
      valid: false,
      missingRequired,
      workflowColumns: [],
      error: `Colunas obrigatórias faltando: ${missingRequired.join(', ')}`
    };
  }
  
  // Encontrar índices das colunas obrigatórias
  const tipoItemIndex = headers.indexOf('Tipo de Item');
  const closedIndex = headers.indexOf('Closed Date');
  
  // Verificar se Tipo de Item vem antes de Closed Date
  if (tipoItemIndex >= closedIndex) {
    return {
      valid: false,
      missingRequired: [],
      workflowColumns: [],
      error: 'A coluna "Tipo de Item" deve vir antes da coluna "Closed Date"'
    };
  }
  
  // Extrair colunas de workflow (entre Tipo de Item e Closed Date)
  const workflowColumns = headers.slice(tipoItemIndex + 1, closedIndex);
  
  // Verificar se há pelo menos uma coluna de workflow
  if (workflowColumns.length === 0) {
    return {
      valid: false,
      missingRequired: [],
      workflowColumns: [],
      error: 'Deve haver pelo menos uma coluna de etapa do fluxo entre "Tipo de Item" e "Closed Date"'
    };
  }
  
  return {
    valid: true,
    missingRequired: [],
    workflowColumns,
    error: null
  };
}
